import ContactView from './contact/ContactView';
import ContactEdit from './contact/ContactEdit';

import ProfileView from './profile/ProfileView';
import ProfileEdit from './profile/ProfileEdit';

import LanguagesView from './languages/LanguagesView';
import LanguagesEdit from './languages/LanguagesEdit';

import CertificateView from './certificates/CertificatesView';
import CertificateEdit from './certificates/CertificatesEdit';

import WorkHistoryView from './work_history/WorkHistoryView';
import WorkHistoryEdit from './work_history/WorkHistoryEdit';

import VulnerableSectorCheckView from './vulnerable_sector_check/VulnerableSectorCheckView';
import VulnerableSectorCheckEdit from './vulnerable_sector_check/VulnerableSectorCheckEdit';

import ReferencesView from './references/ReferencesView';
import ReferencesEdit from './references/ReferencesEdit';

import PrefsAndAvailabilityView from './preferences_and_availability/PrefsAndAvailabilityView';

import SkillsAndExpView from './skills_and_experience/SkillsAndExpView';

import PersonalityView from './personality/PersonalityView';

import CanadianIdView from './canadian_id/CanadianIdView';
import CanadianIdEdit from './canadian_id/CanadianIdEdit';

import EducationView from './education/EducationView';
import EducationEdit from './education/EducationEdit';

import AgreementView from './agreement/AgreementView';

export default {

  ContactView,
  ContactEdit,

  ProfileView,
  ProfileEdit,

  LanguagesView,
  LanguagesEdit,

  CertificateView,
  CertificateEdit,

  WorkHistoryView,
  WorkHistoryEdit,

  VulnerableSectorCheckView,
  VulnerableSectorCheckEdit,

  ReferencesView,
  ReferencesEdit,

  PrefsAndAvailabilityView,

  SkillsAndExpView,

  PersonalityView,

  CanadianIdView,
  CanadianIdEdit,

  EducationView,
  EducationEdit,

  AgreementView,
};
